'use strict';

export default {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/defaults/transitional.js
// module id = 65
// module chunks = 1